<template>
  <div class="p-2">
    <div class="bg-white rounded-lg border border-gray-200 shadow-sm">
      <!-- Header -->
      <div class="px-2 py-2 border-b border-gray-200">
        <h3 class="text-lg font-semibold text-gray-900 capitalize">
          Voucher List
        </h3>
      </div>

      <!-- Content -->
      <div class="flex flex-col p-2">
        <!-- Static Filters Section -->
        <div
          class="flex-shrink-0 px-4 py-2 mb-1 bg-gray-50 rounded-lg border border-gray-200"
        >
          <div
            class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6"
          >
            <!-- Date Range -->
            <div class="col-span-2 space-y-2">
              <label class="block text-xs font-medium text-gray-600"
                >Date Range</label
              >
              <div class="flex space-x-2">
                <input
                  v-model="filters.fromDate"
                  type="date"
                  class="px-3 py-2 w-full text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="From Date"
                />
                <input
                  v-model="filters.toDate"
                  type="date"
                  class="px-3 py-2 w-full text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="To Date"
                />
              </div>
              <div class="flex space-x-1">
                <button
                  @click="setDateFilter('today')"
                  class="px-2 py-1 text-xs text-blue-700 bg-blue-100 rounded transition-colors hover:bg-blue-200"
                >
                  Today
                </button>
                <button
                  @click="setDateFilter('yesterday')"
                  class="px-2 py-1 text-xs text-gray-700 bg-gray-100 rounded transition-colors hover:bg-gray-200"
                >
                  Yesterday
                </button>
                <button
                  @click="setDateFilter('thisWeek')"
                  class="px-2 py-1 text-xs text-gray-700 bg-gray-100 rounded transition-colors hover:bg-gray-200"
                >
                  This Week
                </button>
              </div>
            </div>

            <!-- Customer Name/Phone -->
            <div class="col-span-1">
              <label class="block text-xs font-medium text-gray-600"
                >Customer Name</label
              >
              <input
                v-model="filters.customerName"
                type="text"
                class="px-3 py-2 w-full text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Search customer name or phone..."
              />
            </div>
            <div class="col-span-1">
              <label class="block text-xs font-medium text-gray-600"
                >Customer Phone</label
              >
              <input
                v-model="filters.customerPhone"
                type="text"
                class="px-3 py-2 w-full text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Search customer name or phone..."
              />
            </div>

            <!-- Firm -->
            <div class="col-span-1">
              <label class="block text-xs font-medium text-gray-600"
                >Firm</label
              >
              <input
                v-model="filters.firm"
                type="text"
                class="px-3 py-2 w-full text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Search firm name..."
              />
            </div>

            <!-- Identifier -->
            <div class="col-span-1">
              <label class="block text-xs font-medium text-gray-600"
                >Identifier</label
              >
              <input
                v-model="filters.identifier"
                type="text"
                class="px-3 py-2 w-full text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Search voucher ID..."
              />
            </div>
            <!-- Status -->
            <div class="col-span-1">
              <label class="block text-xs font-medium text-gray-600"
                >Category</label
              >
              <select
                v-model="filters.category"
                class="px-3 py-2 w-full text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">All Categories</option>

                <option
                  v-for="category in serviceCategoryList"
                  :key="category.serviceCategoryId"
                  :value="category.serviceCategoryId"
                >
                  {{ category.label }}
                </option>
              </select>
            </div>
            <div class="col-span-1">
              <label class="block text-xs font-medium text-gray-600"
                >Vendor
              </label>
              <select
                v-model="filters.vendor"
                class="px-3 py-2 w-full text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">All Vendors</option>

                <option
                  v-for="vendor in vendorList"
                  :key="vendor.vendorId"
                  :value="vendor.vendorId"
                >
                  {{ vendor.firstName }} {{ vendor.lastName }}
                </option>
              </select>
            </div>
            <!-- Identifier -->
            <div class="col-span-1">
              <label class="block text-xs font-medium text-gray-600"
                >Service Request No.</label
              >
              <input
                v-model="filters.serviceRequestNumber"
                type="text"
                class="px-3 py-2 w-full text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Search service request number..."
              />
            </div>

            <!-- Status -->
            <div class="col-span-1">
              <label class="block text-xs font-medium text-gray-600"
                >Status</label
              >
              <select
                v-model="filters.status"
                class="px-3 py-2 w-full text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">All Statuses</option>
                <option value="Pending">Pending</option>
                <option value="Completed">Completed</option>
                <option value="Cancelled">Cancelled</option>
                <option value="Processing">Processing</option>
              </select>
            </div>

            <!-- Voucher Type -->
            <div class="col-span-1">
              <label class="block text-xs font-medium text-gray-600"
                >Voucher Type</label
              >
              <select
                v-model="filters.type"
                class="px-3 py-2 w-full text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">All Types</option>
               
                <option value="invoice">Invoice</option>
                <option value="quotation">Counter Quotation</option>
                <option value="customer_chalan">Counter Chalan</option>
              </select>
            </div>

            <!-- Filter Actions -->
            <div class="space-y-2">
              <label class="block text-xs font-medium text-gray-600"
                >Actions</label
              >
              <div class="flex space-x-2">
                <button
                  @click="applyFilters"
                  class="flex-1 px-3 py-2 text-sm text-white bg-blue-600 rounded-md transition-colors hover:bg-blue-700"
                >
                  Apply
                </button>
                <button
                  @click="clearFilters"
                  class="flex-1 px-3 py-2 text-sm text-white bg-gray-500 rounded-md transition-colors hover:bg-gray-600"
                >
                  Clear
                </button>
              </div>
            </div>
          </div>

          <!-- Active Filters Display -->
          <div
            v-if="hasActiveFilters"
            class="pt-4 mt-4 border-t border-gray-200"
          >
            <div class="flex justify-between items-center">
              <div class="flex items-center space-x-2">
                <span class="text-xs font-medium text-gray-600"
                  >Active Filters:</span
                >
                <div class="flex flex-wrap gap-2">
                  <span
                    v-if="appliedFilters.fromDate || appliedFilters.toDate"
                    class="inline-flex items-center px-2 py-1 text-xs text-blue-800 bg-blue-100 rounded-full"
                  >
                    Date: {{ formatAppliedDateRange() }}
                    <button
                      @click="clearDateFilter"
                      class="ml-1 text-blue-600 hover:text-blue-800"
                    >
                      ×
                    </button>
                  </span>
                  <span
                    v-if="appliedFilters.customerName"
                    class="inline-flex items-center px-2 py-1 text-xs text-green-800 bg-green-100 rounded-full"
                  >
                    Customer: {{ appliedFilters.customerName }}
                    <button
                      @click="clearAppliedFilter('customerName')"
                      class="ml-1 text-green-600 hover:text-green-800"
                    >
                      ×
                    </button>
                  </span>
                  <span
                    v-if="appliedFilters.customerPhone"
                    class="inline-flex items-center px-2 py-1 text-xs text-green-800 bg-green-100 rounded-full"
                  >
                    Phone: {{ appliedFilters.customerPhone }}
                    <button
                      @click="clearAppliedFilter('customerPhone')"
                      class="ml-1 text-green-600 hover:text-green-800"
                    >
                      ×
                    </button>
                  </span>
                  <span
                    v-if="appliedFilters.firm"
                    class="inline-flex items-center px-2 py-1 text-xs text-purple-800 bg-purple-100 rounded-full"
                  >
                    Firm: {{ appliedFilters.firm }}
                    <button
                      @click="clearAppliedFilter('firm')"
                      class="ml-1 text-purple-600 hover:text-purple-800"
                    >
                      ×
                    </button>
                  </span>
                  <span
                    v-if="appliedFilters.identifier"
                    class="inline-flex items-center px-2 py-1 text-xs text-orange-800 bg-orange-100 rounded-full"
                  >
                    ID: {{ appliedFilters.identifier }}
                    <button
                      @click="clearAppliedFilter('identifier')"
                      class="ml-1 text-orange-600 hover:text-orange-800"
                    >
                      ×
                    </button>
                  </span>
                  <span
                    v-if="appliedFilters.status"
                    class="inline-flex items-center px-2 py-1 text-xs text-red-800 bg-red-100 rounded-full"
                  >
                    Status: {{ appliedFilters.status }}
                    <button
                      @click="clearAppliedFilter('status')"
                      class="ml-1 text-red-600 hover:text-red-800"
                    >
                      ×
                    </button>
                  </span>
                  <span
                    v-if="appliedFilters.type"
                    class="inline-flex items-center px-2 py-1 text-xs text-indigo-800 bg-indigo-100 rounded-full"
                  >
                    Type: {{ appliedFilters.type }}
                    <button
                      @click="clearAppliedFilter('type')"
                      class="ml-1 text-indigo-600 hover:text-indigo-800"
                    >
                      ×
                    </button>
                  </span>
                </div>
              </div>
              <span class="text-xs text-gray-500">
                {{ pagination.from }}-{{ pagination.to }} of
                {{ pagination.total }} vouchers
              </span>
            </div>
          </div>
        </div>

        <!-- Static Header Row -->
        <div
          class="flex flex-shrink-0 items-center px-4 py-2 font-semibold text-gray-700 bg-gray-50 rounded-lg border border-gray-200"
        >
          <div class="pr-2 w-8 border-r border-gray-300">
            <input
              type="checkbox"
              v-model="selectAll"
              @change="handleSelectAll"
              class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 focus:ring-2"
            />
          </div>
          <div class="px-2 border-r border-gray-300" style="width: 8%">
            Date
          </div>
          <div class="px-2 border-r border-gray-300" style="width: 15%">
            Customer
          </div>
          <div class="px-2 border-r border-gray-300" style="width: 12%">
            Firm
          </div>
          <div class="px-2 border-r border-gray-300" style="width: 13%">
            Voucher Type
          </div>
          <div class="px-2 border-r border-gray-300" style="width: 10%">
            Identifier
          </div>
          <div class="px-2 border-r border-gray-300" style="width: 10%">
            SR No.
          </div>
          <div
            class="px-2 text-right border-r border-gray-300"
            style="width: 10%"
          >
            Amount
          </div>
          <div
            class="px-2 text-right border-r border-gray-300"
            style="width: 12%"
          >
            Received
          </div>
          <div
            class="px-2 text-right border-r border-gray-300"
            style="width: 8%"
          >
            Discount
          </div>
          <div
            class="px-2 text-right border-r border-gray-300"
            style="width: 8%"
          >
            Balance
          </div>
          <div class="px-2 border-r border-gray-300" style="width: 8%">
            Status
          </div>
            <div class="px-2" style="width: 6%">Action</div>
        </div>

        <!-- Scrollable Data Container -->
        <div class="overflow-y-auto" style="max-height: calc(100vh - 450px);">
          <!-- Data Rows -->
          <div
            v-for="(voucher, index) in voucherList"
            :key="index"
            class="flex items-center px-4 border-b border-gray-200 transition-colors duration-150 hover:bg-gray-50"
            :class="{
              'bg-blue-50 border-blue-200': selectedRows.includes(index)
            }"
          >
            <div class="pr-2 w-8 border-r border-gray-300">
              <input
                type="checkbox"
                :value="index"
                v-model="selectedRows"
                @change="handleRowSelect"
                class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 focus:ring-2"
              />
            </div>
            <div
              class="px-2 text-sm text-gray-600 border-r border-gray-300"
              style="width: 8%"
            >
              {{ formatDate(voucher.date) }}
            </div>
            <div
              class="px-2 text-sm font-medium text-gray-900 truncate border-r border-gray-300"
              style="width: 15%"
            >
              {{ voucher.customerName }}
            </div>
            <div
              class="px-2 text-sm text-gray-600 truncate border-r border-gray-300"
              style="width: 12%"
            >
              {{ voucher.firm }}
            </div>
            <div
              class="px-2 text-sm text-gray-600 truncate border-r border-gray-300"
              style="width: 13%"
            >
              {{ voucher.voucherType }}
            </div>
            <div
              class="px-2 font-mono text-sm text-gray-600 border-r border-gray-300"
              style="width: 10%"
            >
              {{ voucher.identifier }}
            </div>
            <div
              class="px-2 text-sm text-gray-600 truncate border-r border-gray-300"
              style="width: 10%"
            >
              {{ voucher.serviceRequestNumber }}
            </div>
            <div
              class="px-2 text-sm font-medium text-right text-gray-900 border-r border-gray-300"
              style="width: 10%"
            >
              ₹{{ formatAmount(voucher.amount) }}
            </div>
            <div
              class="px-2 text-sm text-right text-gray-600 border-r border-gray-300"
              style="width: 12%"
            >
              ₹{{ formatAmount(voucher.received) }}
            </div>
            <div
              class="px-2 text-sm text-right text-gray-600 border-r border-gray-300"
              style="width: 8%"
            >
              ₹{{ formatAmount(voucher.discount) }}
            </div>
            <div
              class="px-2 text-sm font-medium text-right border-r border-gray-300"
              style="width: 8%"
              :class="voucher.balance > 0 ? 'text-red-600' : 'text-green-600'"
            >
              ₹{{ formatAmount(voucher.balance) }}
            </div>
            <div
              class="px-2 text-xs border-r border-gray-300"
              style="width: 8%"
            >
              <el-tag :type="getStatusType(voucher.status)" size="small">
                {{ voucher.status }}
              </el-tag>
            </div>
            <div class="px-2 py-1" style="width: 6%">
              <div class="inline-block relative text-left dropdown-container">
                <div>
                  <button
                    type="button"
                    class="inline-flex justify-center items-center px-2 py-1 w-full text-xs font-medium text-white rounded-md shadow-sm transition-colors duration-150"
                    :class="
                      voucher.isDropdownOpen
                        ? 'bg-blue-600 hover:bg-blue-700'
                        : 'bg-blue-500 hover:bg-blue-600'
                    "
                    id="menu-button"
                    aria-expanded="true"
                    aria-haspopup="true"
                    @click="handleDropdown(voucher, index)"
                  >
                    Actions
                  </button>
                </div>
                <div
                  v-if="voucher.isDropdownOpen"
                  class="absolute right-0 z-50 mt-2 w-48 bg-white rounded-lg border border-gray-200 shadow-xl"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="menu-button"
                  tabindex="-1"
                  style="top: 100%;"
                >
                  <div class="py-2" role="none">
                    <button
                    :disabled="voucher.voucherType !== 'invoice'"
                      @click="handlePayment(voucher, index)"
                      class="flex items-center px-4 py-2 w-full text-sm text-gray-700 transition-colors duration-150 hover:bg-blue-50 hover:text-blue-700"
                      role="menuitem"
                      tabindex="-1"
                      id="menu-item-0"
                    >
                     
                      Make Payment
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Loading State -->
          <div v-if="loading" class="flex justify-center items-center py-12">
            <div class="flex justify-center items-center">
              <div
                class="w-8 h-8 rounded-full border-b-2 border-blue-600 animate-spin"
              ></div>
              <span class="ml-2 text-gray-600">Loading vouchers...</span>
            </div>
          </div>

          <!-- Empty State -->
          <div
            v-else-if="voucherList.length === 0"
            class="flex justify-center items-center py-12"
          >
            <div class="mb-4 text-gray-400">
              <svg
                class="mx-auto w-12 h-12"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <p class="text-lg text-gray-500">No vouchers found</p>
            <p class="mt-1 text-sm text-gray-400">
              Try adjusting your filters or create a new voucher
            </p>
          </div>
        </div>

        <!-- Static Summary Rows -->
        <!-- Selected Rows Summary -->
        <div
          v-if="selectedRows.length > 0"
          class="flex flex-shrink-0 items-center px-4 py-2 font-semibold bg-blue-50 border-b-2 border-blue-200"
        >
          <div class="pr-2 w-8 border-r border-gray-300">
            <span class="text-xs text-blue-600">{{ selectedRows.length }}</span>
          </div>
          <div
            class="px-2 text-sm text-blue-800 border-r border-gray-300"
            style="width: 8%"
          >
            Selected
          </div>
          <div
            class="px-2 text-sm text-blue-800 border-r border-gray-300"
            style="width: 15%"
          >
            {{ selectedRows.length }} items
          </div>
          <div
            class="px-2 text-sm text-blue-800 border-r border-gray-300"
            style="width: 12%"
          >
            -
          </div>
          <div
            class="px-2 text-sm text-blue-800 border-r border-gray-300"
            style="width: 13%"
          >
            -
          </div>
          <div
            class="px-2 text-sm text-blue-800 border-r border-gray-300"
            style="width: 10%"
          >
            -
          </div>
          <div
            class="px-2 text-sm font-bold text-right text-blue-800 border-r border-gray-300"
            style="width: 10%"
          >
            ₹{{ formatAmount(selectedTotals.amount) }}
          </div>
          <div
            class="px-2 text-sm font-bold text-right text-blue-800 border-r border-gray-300"
            style="width: 12%"
          >
            ₹{{ formatAmount(selectedTotals.received) }}
          </div>
          <div
            class="px-2 text-sm font-bold text-right text-blue-800 border-r border-gray-300"
            style="width: 8%"
          >
            ₹{{ formatAmount(selectedTotals.discount) }}
          </div>
          <div
            class="px-2 text-sm font-bold text-right border-r border-gray-300"
            style="width: 8%"
            :class="
              selectedTotals.balance > 0 ? 'text-red-600' : 'text-green-600'
            "
          >
            ₹{{ formatAmount(selectedTotals.balance) }}
          </div>
          <div class="px-2 text-xs border-r border-gray-300" style="width: 8%">
            -
          </div>
          <div class="px-2" style="width: 6%">
            <button
              v-if="selectedInvoices.length > 1"
              @click="handleMultiplePayment"
              class="px-3 py-1 text-xs text-white bg-green-600 rounded hover:bg-green-700"
            >
              Make Payment
            </button>
          </div>
        </div>

        <!-- Total Summary Row -->
        <div
          v-if="!loading && voucherList.length > 0"
          class="flex flex-shrink-0 items-center px-4 py-3 font-bold bg-gray-100 border-t-2 border-gray-300"
        >
          <div class="pr-2 w-8 border-r border-gray-300">
            <span class="text-xs text-gray-600">{{ voucherList.length }}</span>
          </div>
          <div
            class="px-2 text-sm text-gray-800 border-r border-gray-300"
            style="width: 8%"
          >
            Total
          </div>
          <div
            class="px-2 text-sm text-gray-800 border-r border-gray-300"
            style="width: 15%"
          >
            {{ summary.total_vouchers }} vouchers
          </div>
          <div
            class="px-2 text-sm text-gray-800 border-r border-gray-300"
            style="width: 12%"
          >
            -
          </div>
          <div
            class="px-2 text-sm text-gray-800 border-r border-gray-300"
            style="width: 13%"
          >
            -
          </div>
          <div
            class="px-2 text-sm text-gray-800 border-r border-gray-300"
            style="width: 10%"
          >
            -
          </div>
          <div
            class="px-2 text-sm font-bold text-right text-gray-900 border-r border-gray-300"
            style="width: 10%"
          >
            ₹{{ formatAmount(summary.total_amount) }}
          </div>
          <div
            class="px-2 text-sm font-bold text-right text-gray-900 border-r border-gray-300"
            style="width: 12%"
          >
            ₹{{ formatAmount(summary.total_received) }}
          </div>
          <div
            class="px-2 text-sm font-bold text-right text-gray-900 border-r border-gray-300"
            style="width: 8%"
          >
            ₹{{ formatAmount(summary.total_discount) }}
          </div>
          <div
            class="px-2 text-sm font-bold text-right border-r border-gray-300"
            style="width: 8%"
            :class="
              summary.total_balance > 0 ? 'text-red-600' : 'text-green-600'
            "
          >
            ₹{{ formatAmount(summary.total_balance) }}
          </div>
          <div class="px-2 text-xs border-r border-gray-300" style="width: 8%">
            -
          </div>
          <div class="px-2" style="width: 6%">
            -
          </div>
        </div>

        <!-- Static Pagination -->
        <div
          v-if="!loading && voucherList.length > 0"
          class="flex flex-shrink-0 justify-between items-center mt-2"
        >
          <div class="flex items-center space-x-2">
            <label for="per-page" class="text-sm font-medium text-gray-700"
              >Records per page:</label
            >
            <select
              id="per-page"
              v-model="pagination.per_page"
              @change="handlePerPageChange"
              class="px-2 py-1 text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>

          <div class="flex items-center space-x-2">
            <button
              @click="goToPage(pagination.current_page - 1)"
              :disabled="pagination.current_page <= 1"
              class="px-3 py-2 text-sm rounded-md border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Previous
            </button>

            <div class="flex space-x-1">
              <button
                v-for="page in getVisiblePages()"
                :key="page"
                @click="goToPage(page)"
                :class="[
                  'px-3 py-2 text-sm border rounded-md',
                  page === pagination.current_page
                    ? 'bg-blue-600 text-white border-blue-600'
                    : 'border-gray-300 hover:bg-gray-50'
                ]"
              >
                {{ page }}
              </button>
            </div>

            <button
              @click="goToPage(pagination.current_page + 1)"
              :disabled="pagination.current_page >= pagination.last_page"
              class="px-3 py-2 text-sm rounded-md border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Invoice Payment Popup -->
    <invoice-payment-popup
      :show.sync="showPaymentPopup"
      :selected-invoices="selectedInvoices"
      :customer-name="selectedCustomerName"
      :firm-name="selectedFirmName"
      :saving="savingPayment"
      @save="handleSavePayment"
    />
  </div>
</template>

<script>
import endpoints from "../../utils/constants";
import { apiHelper } from "../../utils/helpers";
import snakeToCamel from "../../utils/SnakeToCamel";
import { Tag } from "element-ui";
import InvoicePaymentPopup from "@/components/InvoicePaymentPopup.vue";
import { mapActions } from "vuex";

export default {
  name: "VoucherList",
  components: {
    [Tag.name]: Tag,
    "invoice-payment-popup": InvoicePaymentPopup
  },
  data() {
    return {
      selectAll: false,
      isIndeterminate: false,
      selectedRows: [],
      voucherList: [],
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 20,
        total: 0,
        from: 0,
        to: 0
      },
      summary: {
        total_amount: 0,
        total_received: 0,
        total_discount: 0,
        total_balance: 0,
        total_vouchers: 0
      },
      loading: false,
      filters: {
        fromDate: "",
        toDate: "",
        customerName: "",
        customerPhone: "",
        firm: "",
        identifier: "",
        status: "",
        serviceRequestNumber: "",
        type: "",
        category: "",
        vendor: ""
      },
      appliedFilters: {
        fromDate: "",
        toDate: "",
        customerName: "",
        customerPhone: "",
        firm: "",
        identifier: "",
        status: "",
        type: "",
        category: "",
        vendor: ""
      },
      serviceCategoryList: [],
      vendorList: [],
      showPaymentPopup: false,
      savingPayment: false
    };
  },
  computed: {
    hasActiveFilters() {
      return Object.values(this.appliedFilters).some(value => value !== "");
    },
    selectedTotals() {
      if (this.selectedRows.length === 0) {
        return { amount: 0, received: 0, discount: 0, balance: 0 };
      }

      return this.selectedRows.reduce(
        (totals, index) => {
          const voucher = this.voucherList[index];
          if (voucher) {
            totals.amount += parseFloat(voucher.amount) || 0;
            totals.received += parseFloat(voucher.received) || 0;
            totals.discount += parseFloat(voucher.discount) || 0;
            totals.balance += parseFloat(voucher.balance) || 0;
          }
          return totals;
        },
        { amount: 0, received: 0, discount: 0, balance: 0 }
      );
    },
    selectedInvoices() {
      // Get selected invoices (only invoice type vouchers)
      return this.selectedRows
        .map(index => this.voucherList[index])
        .filter(
          voucher =>
            voucher &&
            voucher.voucherType === "invoice" &&
            voucher.balance > 0
        );
    },
    selectedCustomerName() {
      if (this.selectedInvoices.length === 0) return "";
      return this.selectedInvoices[0].customerName || "";
    },
    selectedFirmName() {
      if (this.selectedInvoices.length === 0) return "";
      return this.selectedInvoices[0].firm || "";
    }
  },
  watch: {
    "filters.fromDate"(newVal) {
      this.appliedFilters.fromDate = newVal;
      this.pagination.current_page = 1;
      this.fetchVouchers();
    },
    "filters.toDate"(newVal) {
      this.appliedFilters.toDate = newVal;
      this.pagination.current_page = 1;
      this.fetchVouchers();
    },
    "filters.status"(newVal) {
      this.appliedFilters.status = newVal;
      this.pagination.current_page = 1;
      this.fetchVouchers();
    },
    "filters.vendor"(newVal) {
      this.appliedFilters.vendor = newVal;
      this.pagination.current_page = 1;
      this.fetchVouchers();
    },
    "filters.category"(newVal) {
      this.appliedFilters.category = newVal;
      this.pagination.current_page = 1;
      this.fetchVouchers();
    },
    "filters.type"(newVal) {
      this.appliedFilters.type = newVal;
      this.pagination.current_page = 1;
      this.fetchVouchers();
    }
  },
  mounted() {
    this.fetchVouchers();
    this.fetchServiceCategoryList();
    this.fetchVendorList();
    this.getPaymentModes();
  },
  methods: {
    ...mapActions({
      getPaymentModes: "paymentMode/getPaymentModes"
    }),
    async fetchServiceCategoryList() {
      const response = await apiHelper.call(
        "get",
        `${endpoints.BASE_URL}${endpoints.API.serviceCategories}`
      );
      this.serviceCategoryList = response.data;
    },
    async fetchVendorList() {
      const response = await apiHelper.call(
        "get",
        `${endpoints.BASE_URL}${endpoints.API.vendors}`
      );
      this.vendorList = response.data;
    },
    async fetchVouchers() {
      this.loading = true;
      try {
        const params = new URLSearchParams();
        params.append("page", this.pagination.current_page);
        params.append("per_page", this.pagination.per_page);

        // Add filters to params
        if (this.appliedFilters.fromDate)
          params.append("from_date", this.appliedFilters.fromDate);
        if (this.appliedFilters.toDate)
          params.append("to_date", this.appliedFilters.toDate);
        if (this.appliedFilters.customerName)
          params.append("customer_name", this.appliedFilters.customerName);
        if (this.appliedFilters.customerPhone)
          params.append("customer_phone", this.appliedFilters.customerPhone);
        if (this.appliedFilters.firm)
          params.append("firm", this.appliedFilters.firm);
        if (this.appliedFilters.identifier)
          params.append("identifier", this.appliedFilters.identifier);
        if (this.appliedFilters.status)
          params.append("status", this.appliedFilters.status);
        if (this.appliedFilters.serviceRequestNumber)
          params.append(
            "service_request_number",
            this.appliedFilters.serviceRequestNumber
          );
        if (this.appliedFilters.vendor)
          params.append("vendor", this.appliedFilters.vendor);
        if (this.appliedFilters.category)
          params.append("category", this.appliedFilters.category);
        if (this.appliedFilters.type)
          params.append("type", this.appliedFilters.type);

        const response = await apiHelper.call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/vouchers?${params.toString()}`
        );

        this.voucherList = response.data.data.map(voucher => ({
          ...snakeToCamel(voucher),
          discount: 0,
          balance: voucher.amount - voucher.received - 0,
          isDropdownOpen: false
        }));

        this.pagination = {
          current_page: response.data.pagination.current_page,
          last_page: response.data.pagination.last_page,
          per_page: response.data.pagination.per_page,
          total: response.data.pagination.total,
          from: response.data.pagination.from,
          to: response.data.pagination.to
        };

        // Update summary from API response
        if (response.data.summary) {
          const totalAmount = response.data.summary.total_amount || 0;
          const totalReceived = response.data.summary.total_received || 0;
          const totalDiscount = response.data.summary.total_discount || 0;
          const totalVouchers = response.data.summary.total_vouchers || 0;

          this.summary = {
            total_amount: totalAmount,
            total_received: totalReceived,
            total_discount: totalDiscount,
            total_balance: totalAmount - totalReceived - totalDiscount,
            total_vouchers: totalVouchers
          };
        }
      } catch (error) {
        console.error("Error fetching vouchers:", error);
        this.$message.error("Failed to fetch vouchers");
      } finally {
        this.loading = false;
      }
    },
    goToPage(page) {
      if (page >= 1 && page <= this.pagination.last_page) {
        this.pagination.current_page = page;
        this.fetchVouchers();
      }
    },
    handlePerPageChange() {
      this.pagination.current_page = 1;
      this.fetchVouchers();
    },
    getVisiblePages() {
      const current = this.pagination.current_page;
      const last = this.pagination.last_page;
      const delta = 2;
      const range = [];
      const rangeWithDots = [];

      for (
        let i = Math.max(2, current - delta);
        i <= Math.min(last - 1, current + delta);
        i++
      ) {
        range.push(i);
      }

      if (current - delta > 2) {
        rangeWithDots.push(1, "...");
      } else {
        rangeWithDots.push(1);
      }

      rangeWithDots.push(...range);

      if (current + delta < last - 1) {
        rangeWithDots.push("...", last);
      } else if (last > 1) {
        rangeWithDots.push(last);
      }

      return rangeWithDots;
    },
    handleSelectAll() {
      this.selectedRows = this.selectAll
        ? this.voucherList.map((_, index) => index)
        : [];
      this.isIndeterminate = false;
    },
    handleRowSelect() {
      const selectedCount = this.selectedRows.length;
      this.selectAll = selectedCount === this.voucherList.length;
      this.isIndeterminate =
        selectedCount > 0 && selectedCount < this.voucherList.length;
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("en-IN");
    },
    formatAmount(amount) {
      return new Intl.NumberFormat("en-IN").format(amount);
    },
    getStatusType(status) {
      const statusTypes = {
        Pending: "warning",
        Completed: "success",
        Cancelled: "danger",
        Processing: "info"
      };
      return statusTypes[status] || "info";
    },
    handleDropdown(voucher, index) {
      // Close all other dropdowns first
      this.voucherList = this.voucherList.map((item, i) => ({
        ...item,
        isDropdownOpen: i === index ? !item.isDropdownOpen : false
      }));
    },
    handleView(voucher, index) {
      // Close the dropdown
      this.handleDropdown(voucher, index);
      this.$message.info(`Viewing voucher: ${voucher.identifier}`);
      // Add your view logic here
    },
    handleEdit(voucher, index) {
      // Close the dropdown
      this.handleDropdown(voucher, index);
      this.$message.info(`Editing voucher: ${voucher.identifier}`);
      // Add your edit logic here
    },
    handleDelete(voucher, index) {
      // Close the dropdown
      this.handleDropdown(voucher, index);
      this.$confirm(
        "Are you sure you want to delete this voucher?",
        "Confirm Delete",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning"
        }
      )
        .then(() => {
          this.voucherList.splice(index, 1);
          this.$message.success("Voucher deleted successfully");
        })
        .catch(() => {
          this.$message.info("Delete cancelled");
        });
    },
    setDateFilter(type) {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - today.getDay());

      switch (type) {
        case "today":
          this.filters.fromDate = today.toISOString().split("T")[0];
          this.filters.toDate = today.toISOString().split("T")[0];
          break;
        case "yesterday":
          this.filters.fromDate = yesterday.toISOString().split("T")[0];
          this.filters.toDate = yesterday.toISOString().split("T")[0];
          break;
        case "thisWeek":
          this.filters.fromDate = startOfWeek.toISOString().split("T")[0];
          this.filters.toDate = today.toISOString().split("T")[0];
          break;
      }
      // Watchers will handle the API call
    },
    clearDateFilter() {
      this.filters.fromDate = "";
      this.filters.toDate = "";
      // Watchers will handle the API call
    },
    formatDateRange() {
      if (this.filters.fromDate && this.filters.toDate) {
        if (this.filters.fromDate === this.filters.toDate) {
          return this.formatDate(this.filters.fromDate);
        } else {
          return `${this.formatDate(this.filters.fromDate)} - ${this.formatDate(
            this.filters.toDate
          )}`;
        }
      } else if (this.filters.fromDate) {
        return `From ${this.formatDate(this.filters.fromDate)}`;
      } else if (this.filters.toDate) {
        return `Until ${this.formatDate(this.filters.toDate)}`;
      }
      return "";
    },
    formatAppliedDateRange() {
      if (this.appliedFilters.fromDate && this.appliedFilters.toDate) {
        if (this.appliedFilters.fromDate === this.appliedFilters.toDate) {
          return this.formatDate(this.appliedFilters.fromDate);
        } else {
          return `${this.formatDate(
            this.appliedFilters.fromDate
          )} - ${this.formatDate(this.appliedFilters.toDate)}`;
        }
      } else if (this.appliedFilters.fromDate) {
        return `From ${this.formatDate(this.appliedFilters.fromDate)}`;
      } else if (this.appliedFilters.toDate) {
        return `Until ${this.formatDate(this.appliedFilters.toDate)}`;
      }
      return "";
    },
    clearAppliedFilter(filterName) {
      this.appliedFilters[filterName] = "";
      this.filters[filterName] = "";
      this.pagination.current_page = 1;
      this.fetchVouchers();
    },
    applyFilters() {
      // Copy current filter values to applied filters
      this.appliedFilters = { ...this.filters };
      this.pagination.current_page = 1;
      this.fetchVouchers();
    },
    clearFilters() {
      this.filters = {
        fromDate: "",
        toDate: "",
        customerName: "",
        customerPhone: "",
        firm: "",
        identifier: "",
        status: "",
        type: ""
      };
      this.appliedFilters = {
        fromDate: "",
        toDate: "",
        customerName: "",
        customerPhone: "",
        firm: "",
        identifier: "",
        status: "",
        type: ""
      };
      this.pagination.current_page = 1;
      this.fetchVouchers();
    },
    handlePayment(voucher, index) {
      this.handleDropdown(voucher, index);
      
      // Check if it's an invoice
      if (voucher.voucherType !== "invoice") {
        this.$notify({
          message: "Payment can only be made for invoices",
          type: "warning",
          title: "Warning"
        });
        return;
      }

      // Check if there's a balance
      if (voucher.balance <= 0) {
        this.$notify({
          message: "This invoice has no outstanding balance",
          type: "warning",
          title: "Warning"
        });
        return;
      }

      // Open payment popup with single invoice
      this.selectedRows = [index];
      this.showPaymentPopup = true;
    },
    handleMultiplePayment() {
      // Validate that all selected are invoices
      const nonInvoiceVouchers = this.selectedRows
        .map(index => this.voucherList[index])
        .filter(v => v.voucherType !== "invoice");

      if (nonInvoiceVouchers.length > 0) {
        this.$notify({
          message: "Please select only invoices for payment. Other voucher types cannot be paid together.",
          type: "danger",
          title: "Error"
        });
        return;
      }

      // Validate same customer and firm
      if (!this.validateSelectedInvoices()) {
        return;
      }

      // Check if any invoice has balance
      const invoicesWithBalance = this.selectedInvoices.filter(
        inv => inv.balance > 0
      );

      if (invoicesWithBalance.length === 0) {
        this.$notify({
          message: "Selected invoices have no outstanding balance",
          type: "warning",
          title: "Warning"
        });
        return;
      }

      // Open payment popup
      this.showPaymentPopup = true;
    },
    validateSelectedInvoices() {
      if (this.selectedInvoices.length < 2) {
        return true; // Single invoice doesn't need validation
      }

      const firstInvoice = this.selectedInvoices[0];
      const customerName = firstInvoice.customerName;
      const firm = firstInvoice.firm;

      // Check if all invoices have same customer and firm
      const invalidInvoices = this.selectedInvoices.filter(
        inv =>
          inv.customerName !== customerName || inv.firm !== firm
      );

      if (invalidInvoices.length > 0) {
        this.$notify({
          message: "All selected invoices must be from the same customer and same firm. Please select invoices with matching customer and firm.",
          type: "danger",
          title: "Error"
        });
        return false;
      }

      return true;
    },
    async handleSavePayment(paymentData) {
      this.savingPayment = true;
      try {
        // Prepare payment data for API
        const paymentPayload = {
          invoice_payments: paymentData.invoicePayments,
          payment_breakdown: paymentData.paymentBreakdown,
          payment_note: paymentData.paymentNote,
          total_paid: paymentData.totalPaid
        };

        // Call API to save payment
        const response = await apiHelper.call(
          "post",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/vouchers/payment`,
          paymentPayload
        );

        this.$notify({
          message: "Payment saved successfully!",
          type: "success",
          title: "Success"
        });
        this.showPaymentPopup = false;
        
        // Refresh voucher list
        await this.fetchVouchers();
        
        // Clear selection
        this.selectedRows = [];
        this.selectAll = false;
      } catch (error) {
        console.error("Error saving payment:", error);
        const errorMessage =
          (error.response && error.response.data && error.response.data.message) ||
          "Failed to save payment";
        this.$notify({
          message: errorMessage,
          type: "danger",
          title: "Error"
        });
      } finally {
        this.savingPayment = false;
      }
    }
  }
};
</script>
